export enum AdditionalInformationType {
  CheckoutEmailIntroText = 'checkout-email-intro-text',
  CheckoutEmailMidText = 'checkout-email-mid-text',
  CheckoutEmailEndText = 'checkout-email-end-text',
  CustomCapSaveEmailBody = 'custom-cap-save-email-body',
  CustomQuotePurchaserAgreement = 'custom-quote-purchaser-agreement',
  CustomQuoteEmailBody = 'custom-quote-email-body',
  CustomQuoteSaveEmailBody = 'custom-quote-save-email-body',
  CustomQuoteCheckoutEmailBody = 'custom-quote-checkout-email-body',
  EstimateEndText = 'estimate-end-text',
  EstimateIntroText = 'estimate-intro-text',
  EstimateNoPricingText = 'estimate-no-pricing-text',
  LineItem = 'line-item',
  PdfSignatureAgreement = 'pdf-signature-agreement',
  SaveEmailIntroText = 'save-email-intro-text',
  SaveEmailMidText = 'save-email-mid-text',
  SaveEmailEndText = 'save-email-end-text',
  ServicesFinancing = 'services-financing',
  QuoteEmailIntroText = 'quote-email-intro-text',
  QuoteEmailMidText = 'quote-email-mid-text',
  QuoteEmailEndText = 'quote-email-end-text',
  QuoteTermsOfService = 'quote-terms-of-service',
}
